import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "navy" | "quiet" | "ghost";

const variantClasses: Record<Variant, string> = {
  primary: "bg-primary text-primary-foreground hover:bg-primary-hover",
  navy: "bg-brand-navy text-white hover:opacity-90",
  quiet: "bg-card text-foreground border border-border hover:bg-muted",
  ghost: "bg-transparent text-foreground border border-border hover:bg-muted"
};

export function Button({
  variant = "primary",
  className = "",
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  return (
    <button
      type="button"
      className={`touch-target inline-flex min-h-[48px] items-center justify-center gap-2 rounded-sm px-4 font-action text-[15px] font-bold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
